import React from "react";

function AddressTitleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
    >
      <g clip-path="url(#clip0_1925_435)">
        <path
          d="M7.5832 18.3C9.38672 16.043 13.5 10.5727 13.5 7.5C13.5 3.77344 10.4766 0.75 6.75 0.75C3.02344 0.75 0 3.77344 0 7.5C0 10.5727 4.11328 16.043 5.9168 18.3C6.34922 18.8379 7.15078 18.8379 7.5832 18.3ZM6.75 5.25C7.34674 5.25 7.91903 5.48705 8.34099 5.90901C8.76295 6.33097 9 6.90326 9 7.5C9 8.09674 8.76295 8.66903 8.34099 9.09099C7.91903 9.51295 7.34674 9.75 6.75 9.75C6.15326 9.75 5.58097 9.51295 5.15901 9.09099C4.73705 8.66903 4.5 8.09674 4.5 7.5C4.5 6.90326 4.73705 6.33097 5.15901 5.90901C5.58097 5.48705 6.15326 5.25 6.75 5.25Z"
          fill="#2563EB"
        />
      </g>
      <defs>
        <clipPath id="clip0_1925_435">
          <path d="M0 0.75H13.5V18.75H0V0.75Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AddressTitleIcon;
